import React from 'react';
import { IRoute } from '../../../../interfaces';
import { NavLink } from 'react-router-dom';
import { useMainLayout } from '../../../../lib';
import './Route.scss';
import { HiOutlineTicket } from 'react-icons/hi';
import { ReactComponent as DashboardIcon } from '../../../../../../shared/assets/svgs/DashboardIcon.svg';
import { ReactComponent as PeopleIcon } from '../../../../../../shared/assets/svgs/PeopleIcon.svg';
import { ReactComponent as TildeDashboardIcon } from '../../../../../../shared/assets/svgs/TildeDashboardIcon.svg';
import { ReactComponent as SettingDashboardIcon } from '../../../../../../shared/assets/svgs/SettingDashboardIcon.svg';

interface RouteProps {
    route: IRoute;
}

export const Route: React.FC<RouteProps> = (props) => {
    const { route } = props;

    const { setCurrentPath } = useMainLayout();
    return (
        <NavLink
            to={route.tabs[0]?.path}
            className='widget-main-layout-route'
            // FIXME: something wrong in typing of "react-router-dom"
            // @ts-ignore
            onClick={() => setCurrentPath(route.tabs[0]?.path)}
        >
            {route.icon && (
                <div className='widget-main-layout-route__icon-block'>
                    {route.icon.toString() !== 'Ticket' &&
                        route.icon.toString() !== 'Dashboard' &&
                        route.icon.toString() !== 'RIAs' &&
                        route.icon.toString() !== 'Threshold' &&
                        route.icon.toString() !== 'Preferences' && (
                            <etna-icon
                                color={'secondary'}
                                size={'s'}
                                name={route.icon}
                            />
                        )}
                    {route.icon.toString() == 'Ticket' && <HiOutlineTicket />}
                    {route.icon.toString() == 'Dashboard' && <DashboardIcon />}
                    {route.icon.toString() == 'RIAs' && <PeopleIcon />}
                    {route.icon.toString() == 'Threshold' && <TildeDashboardIcon />}
                    {route.icon.toString() == 'Preferences' && <SettingDashboardIcon />}
                </div>
            )}
            <span>{route.name}</span>
        </NavLink>
    );
};
